import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { scrollToElement } from './scroll.utils'
import { IRootState } from '../store'
import { setScrollTargetID } from '../components/scrollToTopButton/store/scrollToTop.actions'

export const useScrollRestoration = () => {
  const dispatch = useDispatch()
  const { scrollTargetID } = useSelector((state: IRootState) => state.scrollToTop)

  useEffect(() => {
    if (!scrollTargetID) return

    requestAnimationFrame(() => {
      scrollToElement(scrollTargetID)
      dispatch(setScrollTargetID(''))
    })
  }, [scrollTargetID, dispatch])
}
